import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../constants';
import { useAdUnit } from '../../useAdUnit';
import DealerAdIframe from '../dealer';
const DesktopDevPageStage728x90 = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['DesktopDevPageStage728x90Gam'], safety, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            728,
            90
        ],
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '728px',
                height: '90px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['DesktopDevPageStage728x90Gam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
